export default __webpack_public_path__ + "static/media/main_banner.954c67e0.jpg";